import { Base, Component, Mixins, Prop } from '@/vue-property-decorator'
import AdvertisementImgBox from '../components/advertisementImgBox'
import BasePropsConfig, { SquareProps } from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import FallbackBackground from '../../components/fallbackBackground'
import FavoriteIcon from '../../components/favoriteIcon'
import GameNameNormal from './gameNameNormal'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from '../components/outerBox'
const ExhibitFallbackBg = FallbackBackground.ExhibitFallbackBg
import style from './style.module.scss'
/** cssSizeType的样式类型 */
export enum SquareBelowNameCssSizeType {
  Default = 'default',
  Small = 'small'
}
type Props = SquareProps & {
  /** 样式 */
  cssSizeType?: SquareBelowNameCssSizeType
}
/** 游戏卡片-标准版
 * 上方正方型图片,下方结合文字
 */
@Component<SquareBelowName>({
  name: 'SquareBelowName'
})
export default class SquareBelowName extends Mixins<
  Base<unknown, Props>,
  BasePropsConfig
>(Base, BasePropsConfig) {
  /** 样式尺寸类型 */
  public static CssSizeType = SquareBelowNameCssSizeType

  /** 获得props */
  public static getProps = BasePropsConfig.getProps

  @Prop({ default: 'default' })
  protected cssSizeType!: Required<Props>['cssSizeType']
  /** 控制显示背景图 */
  private exhibitFallbackBg = new ExhibitFallbackBg()

  // 渲染入口.
  render() {
    const { cssSizeType } = this
    const { isFavorited, isMaintain, isShowFavorited } = this.cardProps
    const { status } = this.cardProps
    return (
      <OuterBox
        class={{
          ['square-below-name']: true,
          [style['square-below-name']]: true,
          [style[`type-${cssSizeType}`]]: true
        }}
        onClick={this.handleClickCard}
      >
        {/* 裁剪盒子 */}
        <BoxCut>
          {/* 卡片主体基础内容 */}
          <AdvertisementImgBox
            onLoadedResult={this.exhibitFallbackBg.setIsShowBgByAdvertiser}
          />
          {/* 将被裁剪的悬浮元素 */}
          <template slot="cutSuspense">
            {/* 兜底背景图 */}
            {this.exhibitFallbackBg.isShow && (
              <FallbackBackground></FallbackBackground>
            )}
            {/* 游戏状态标签 */}
            {status &&
              (this.$scopedSlots.labelGameStatus?.() || <LabelGameStatus />)}
            {/* 维护状态悬浮层 */}
            {isMaintain && <MaskMaintain />}
          </template>
          {/* 不被裁剪的悬浮元素 */}
          <template slot="unCutSuspense">
            {/* 收藏图标放置在box-cut之外,不会被overflow:hidden裁剪 */}
            {isShowFavorited && (
              <FavoriteIcon
                isFavorited={isFavorited}
                onClick={this.handleClickFavorIcon}
              >
                <FavoriteIcon.CircleStar></FavoriteIcon.CircleStar>
              </FavoriteIcon>
            )}
          </template>
        </BoxCut>
        {/* 游戏名称 */}
        <GameNameNormal></GameNameNormal>
      </OuterBox>
    )
  }
}
